import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef } from '@angular/core';
import { 
    InfiniteScrollCustomEvent, IonInfiniteScroll,  IonInfiniteScrollContent 
} from '@ionic/angular/standalone';
import { PhotoGalleryItem, PhotoGalleryItemComponent } from '@app/components';
import { Photo } from '@app/models';

@Component({
    selector: 'app-photo-gallery-mozaic',
    templateUrl: './mozaic.component.html',
    styleUrls: ['./mozaic.component.scss'],
    imports: [
        IonInfiniteScroll, IonInfiniteScrollContent, forwardRef(() => PhotoGalleryItemComponent)
    ]
})
export class PhotoGalleryMozaicComponent  implements OnInit {

    @Input({alias : 'photos', required : false}) photos: Array<Photo> = [];  
    @Input({alias : 'size', required : false}) sizePhoto: 'small'|'medium'|'big' = 'medium';
    @Output() onSelectPhoto = new EventEmitter<PhotoGalleryItem>();
    
    photosItemsDisplayed: Array<PhotoGalleryItem> = [];
    maxPhotosDisplayed: number = 100;
    indexPhotoDisplayed: number = 0;
    disabledInfiniteScroll: boolean = false;

    constructor() { }

    ngOnInit() {}
    
    async ngOnChanges(changes: SimpleChanges) {        
        if(changes['photos']){
            this.photosItemsDisplayed = [];
            this.indexPhotoDisplayed = 0;
            this.disabledInfiniteScroll = false;
            this.getPhotosDisplayed();
        }
    }
    
    getPhotosDisplayed() {
        let subArray = this.photos.slice(this.indexPhotoDisplayed, this.indexPhotoDisplayed+this.maxPhotosDisplayed);
        if(subArray.length > 0){
            this.photosItemsDisplayed = this.photosItemsDisplayed.concat(subArray.map(p => PhotoGalleryItem.FromPhoto(p)));
            this.indexPhotoDisplayed += subArray.length;
        }
        else{
            this.disabledInfiniteScroll = true;
        }
    }

    onIonInfinite(event: InfiniteScrollCustomEvent) { 
        this.getPhotosDisplayed();
        event.target.complete();
    }    
    
    selectPhoto(photo: PhotoGalleryItem){
        this.onSelectPhoto.emit(photo);
    }
}
